import { endpoint } from "../../../../common/constant";
import { fetchAllPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";

export const REPORT_TYPE = [
  { label: "Daily Collection Report", value: "DAILY_COLLECTION_REPORT" },
];

export const FORM_DEFAULT_VALUE = {
  reportType: "",
  collectionFromDate: "",
  collectionToDate: "",
  businessAreaList: [],
  termValueList: [],
  courseIdList: [],
};

export const getAllActiveTerm = async () => {
  const res = await fetchAllPromisedData(`${endpoint?.term.getAllActive}`);

  if (res.length) {
    return res.map((obj) => ({
      label: obj.termDispValue,
      value: obj.termDispValue,
      id: obj.id,
    }));
  }

  return [];
};

export const getDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(endpoint?.businessArea.getAllActiveV2, "businessArea"),
    dropdownMapping(endpoint.term.getAllActive, "term"),
  ]);

  return {
    businessArea: p[0],
    term: p[1],
  };
};

async function dropdownMapping(url, displayLabel) {
  const responseData = await fetchAllPromisedData(url, false);

  if (displayLabel == "businessArea") {
    const result = responseData?.map((item) => ({
      label: `${item.businessAreaDispValue}`,
      value: item.businessAreaDispValue,
      businessAreaId: item.id,
      regionId: item.regionId || "",
      gstInNumber: item.gstInNumber || "",
    }));
    return result ?? [];
  }

  if (displayLabel == "term") {
    const result = responseData?.map((obj) => {
      return { label: obj.termDispValue, value: obj.termDispValue, id: obj.id };
    });
    return result ?? [];
  }
}

export const titleStyles = {
  fontSize: "20px",
  fontWeight: 700,
  color: "#262626",
  fontFamily: "Gilroy-Medium",
};

export const labelStyles = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#262626",
};

export const selectStyles = {
  control: { height: "40px", width: "160px", borderRadius: "4px" },
};
